import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { Box, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
    tooltip: {
        backgroundColor: "#f8f8f8",
        color: "#b71c1c",
        maxWidth: 300,
        border: "1px solid #b71c1c",
    },
    fontRule: {
        fontWeight: 300,
        fontSize: 17,
    },
    redText: {
        color: "#b71c1c",
    },
    greenText: {
        color: "#388e3c",
    },
}));

type PasswordRules = {
    length: boolean;
    lower: boolean;
    upper: boolean;
    number: boolean;
    special: boolean;
    valid: boolean;
};

interface PasswordTooltipProps {
    open: boolean;
    passwordRules: PasswordRules;
    children: React.ReactNode;
}

const PasswordTooltip: React.FC<PasswordTooltipProps> = ({
    open,
    passwordRules,
    children,
}) => {
    const styles = useStyles();
    const [t] = useTranslation();

    return (
        <Tooltip
            classes={{ tooltip: styles.tooltip }}
            title={
                !passwordRules.valid ? (
                    <div>
                        <Typography
                            className={`${styles.fontRule} ${passwordRules.length ? styles.greenText : styles.redText}`}
                        >
                           {t("login.completeInvite.passwordRules.characterLength")}
                        </Typography>
                        <Box mt={1} />
                        <Typography className={`${styles.fontRule} ${styles.redText}`}>
                            {t("login.completeInvite.passwordRules.mustContain")}
                        </Typography>
                        <Typography
                            className={`${styles.fontRule} ${passwordRules.lower ? styles.greenText : styles.redText}`}
                        >
                            {t("login.completeInvite.passwordRules.lowerCase")}
                        </Typography>
                        <Typography
                            className={`${styles.fontRule} ${passwordRules.upper ? styles.greenText : styles.redText}`}
                        >
                            {t("login.completeInvite.passwordRules.upperCase")}
                        </Typography>
                        <Typography
                            className={`${styles.fontRule} ${passwordRules.number ? styles.greenText : styles.redText}`}
                        >
                            {t("login.completeInvite.passwordRules.numbers")}
                        </Typography>
                        <Typography
                            className={`${styles.fontRule} ${passwordRules.special ? styles.greenText : styles.redText}`}
                        >
                            {t("login.completeInvite.passwordRules.specialCharacters")}
                        </Typography>
                    </div>
                ) : (
                    ""
                )
            }
            placement="right"
            arrow
            open={open && !passwordRules.valid}
        >
            <div>{children}</div>
        </Tooltip>
    );
};

export default PasswordTooltip;